<template>
    <div>
        <template v-if="register_loading">
            <div class="d-flex align-items-center justify-content-center py-5">
                <h4 class="mb-1 mr-2">
                    {{
                        !is_project_duplicated ? $t(`평가신청 및 회원정보를 등록 중입니다`) : $t(`평가신청 중입니다`)
                    }}
                </h4>
                <b-spinner type="grow" style="width: 0.5rem;height: 0.5rem;"></b-spinner>
                <b-spinner type="grow" style="width: 0.5rem;height: 0.5rem;"
                           class="mx-1"></b-spinner>
                <b-spinner type="grow" style="width: 0.5rem;height: 0.5rem;"></b-spinner>
            </div>
        </template>
        <template v-else>
            <div v-if="!is_conflict_register">
                <div class="mb-3">
                    <h4 class="mb-3">{{ $t(`아래와 같은 내역으로 평가신청을 완료하였습니다.`) }}</h4>
                    <b-card bg-variant="warning" class="p-3 mb-4" no-body>
                        <template v-if="requestedDetails.project_access_status === 0">
                            <p class="fw-500 text-dark mb-0">
                                <b>{{ $t(role_mapping[requestedDetails.project_role]) }}</b>
                                <span
                                    class="fw-400">{{ $t('권한으로 평가신청 되셨으며 로그인 후 평가에 참여해주세요.') }}</span>
                            </p>
                        </template>
                        <template v-else-if="requestedDetails.project_access_status === 1">
                            <p class="fw-500 text-dark">
                                {{ $t(role_mapping[requestedDetails.project_role]) }}
                                {{ $t('권한으로 평가신청이 완료되었습니다.') }}
                            </p>
                            <p class="fw-500 text-dark mb-0">
                                {{ $t('평가신청과 동시에 평가 관리자에게 평가참여 요청을 하였습니다. 평가참여 승인시 평가 참여 등록이 완료되며 이메일로 알려드리겠습니다.') }}
                            </p>
                        </template>
                        <template v-else>
                            <p class="fw-500 text-dark">
                                {{ $t(role_mapping[requestedDetails.project_role]) }}
                                {{ $t('권한으로 신청 되었으나, 현재 기업 평가 관리자의 승인을 기다리는 중입니다.') }}
                            </p>

                            <p class="fw-500 text-dark mb-0">
                                {{ $t('평가 관리자가 승인하면 별도의 이메일 안내가 발송됩니다. 이메일 안내에 따라 로그인하여 주십시오.') }}
                            </p>
                        </template>
                    </b-card>
                </div>

                <b-card no-body class="mb-3">
                    <b-tabs card>
                        <b-tab :title="$t('평가참여 기업 정보')" active>
                            <b-row>
                                <b-col cols="12" lg="4" class="mb-3">
                                    <p class="f-95 mb-1"> {{ $t('업체코드') }}</p>
                                    <h5 class="f-110 mb-0">{{
                                            requestedDetails.vendor_code
                                        }}</h5>
                                </b-col>
                                <b-col cols="12" lg="4" class="mb-3">
                                    <P class="f-95 mb-1"> {{ $t('회사명') }} </p>
                                    <h5 v-show="$i18n.locale === 'ko'" class="f-110 mb-0">
                                        {{ requestedDetails.company_name || ' - ' }}</h5>
                                    <h5 v-show="$i18n.locale !== 'ko'" class="f-110 mb-0">
                                        {{ requestedDetails.company_name_en || ' - ' }}</h5>
                                </b-col>
                                <b-col cols="12" lg="4" class="mb-3">
                                    <P class="f-95 mb-1">{{ $t('기업 평가 관리자') }}</p>
                                    <h5 class="f-110 mb-0">
                                        {{ requestedDetails.company_manager || ' - ' }}</h5>
                                </b-col>
                                <b-col cols="12" lg="4" class="mb-3 mb-lg-0">
                                    <P class="f-95 mb-1">{{ $t('법인등록번호') }}</p>
                                    <h5 class="f-110 mb-0">
                                        {{ requestedDetails.corporate_code || ' - ' }}</h5>
                                </b-col>
                                <b-col cols="12" lg="4" class="mb-3 mb-lg-0">
                                    <P class="f-95 mb-1"> {{ $t('사업자등록번호') }}</p>
                                    <h5 class="f-110 mb-0">
                                        {{ requestedDetails.company_code || ' - ' }}</h5>
                                </b-col>
                                <b-col cols="12" lg="4">
                                    <P class="f-95 mb-1">{{ $t('DUNS Number') }}</p>
                                    <h5 class="f-110 mb-0">
                                        {{ requestedDetails.duns_number || ' - ' }}</h5>
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab :title="$t('평가참여 신청자 정보')">
                            <b-row>
                                <b-col cols="12" lg="6" class="mb-3">
                                    <p class="f-95 mb-1">{{ $t('계정 email (ID)') }}</p>
                                    <h5 class="f-110 mb-0">
                                        {{ requestedDetails.requested_email }}</h5>
                                </b-col>
                                <b-col cols="12" lg="6" class="mb-3">
                                    <p class="f-95 mb-1">{{ $t('이름') }} <span
                                        v-show="requestedDetails.requested_phone_tell">{{ $t('및 연락처') }}</span>
                                    </p>
                                    <h5 class="f-110 mb-0">
                                        {{ requestedDetails.requested_user_name }} <span>/ {{
                                            requestedDetails.requested_phone_tell || '  -  '
                                        }}</span></h5>
                                </b-col>
                                <b-col cols="12" lg="6" class="mb-3 mb-lg-0">
                                    <p class="f-95 mb-1">{{ $t('참여 유형') }}</p>
                                    <h5 class="f-110 mb-0">{{
                                            $t(role_mapping[requestedDetails.project_role])
                                        }}</h5>
                                </b-col>
                                <b-col cols="12" lg="6">
                                    <p class="f-95 mb-1">{{ $t('참여 상태') }}</p>
                                    <h5 class="f-110 mb-0">{{
                                            $t(access_status_mapping[requestedDetails.project_access_status])
                                        }}</h5>
                                </b-col>
                            </b-row>
                        </b-tab>
                    </b-tabs>
                </b-card>
            </div>
            <div v-else class="py-5">
                <h4 class="mb-1">{{ $t(`평가 신청에 실패하였습니다. 운영팀에 문의해주세요.`) }}
                </h4>
            </div>
        </template>
        
        <div v-if="is_conflict_register">
            <hr/>
        </div>

        <CommonRegisterFooter v-if="!register_loading">
            <template v-if="!is_conflict_register">
                <b-btn variant="secondary"
                       :to="{ name: 'Login' }"
                       :disabled="register_loading"
                >
                    {{ $t(`로그인`) }}
                </b-btn>
            </template>
            <template v-else>
                <b-btn variant="secondary"
                       class="ml-2"
                       :disabled="register_loading"
                       @click="goToStartRegister"
                >
                    {{ $t(`처음으로`) }}
                </b-btn>
            </template>
        </CommonRegisterFooter>
    </div>
</template>

<script>
import {mapState} from 'vuex';
import {access_status_mapping, role_mapping} from '@/components/auth/Register/_SubComponents/data';
import CommonRegisterFooter from '@/components/auth/Register/_SubComponents/CommonRegisterFooter.vue';

export default {
    name: 'RegisterStep3',
    components: {CommonRegisterFooter},
    props: {
        requestedDetails: {
            type: Object,
            default: () => ({}),
        },
    }, 
    data() {
        return {
        };
    },
    computed: {
        ...mapState('register', ['register_loading', 'is_conflict_register', 'is_project_duplicated']),
        role_mapping(){
            return role_mapping;
        },
        access_status_mapping(){
            return access_status_mapping;
        }
    },
    methods: {
        goToStartRegister() {
            window.location.reload();
        }
    },
};
</script>

<style lang="scss" scoped>

</style>
